import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// material ui
import Box from '@mui/material/Box'

// atomic components
import PopupNotifications from 'components/shared/PopupNotifications'
import ResetErrorMessage from 'components/shared/ResetErrorMessage'
import ScrollToTop from 'components/shared/ScrollToTop'
import NotFound from 'components/shared/NotFound'

// local components
import Header from './Header'

// containers using logic shared by registration and account manager
import Overview from 'components/register/Overview'

// Create account
import NewAccount from 'components/register/NewAccount'

// Campers
import NewCamper from 'components/register/Campers/New'
import EditCamper from 'components/register/Campers/Edit'

// Parents
import NewParent from 'components/register/Parents/New'
import EditParent from 'components/register/Parents/Edit'

// Emergency Contacts
import NewEmergencyContact from 'components/register/EmergencyContacts/New'
import EditEmergencyContact from 'components/register/EmergencyContacts/Edit'

// Pickup People
import NewPickupPerson from 'components/register/PickupPeople/New'
import EditPickupPerson from 'components/register/PickupPeople/Edit'

// Cart, payment, confirm, complete
import Cart from 'components/register/Cart'
import Payment from 'components/register/Payment'
import Confirm from 'components/register/Confirm'
import Complete from 'components/register/Complete'

// containers shared with account manager
import AccountFooter from 'components/shared/AccountFooter'

const RegistrationRoutes = ({ basename }) => (
  <BrowserRouter basename={basename}>
    <ScrollToTop />
    <ResetErrorMessage />
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      }}
    >
      <Header basename={basename} />
      <PopupNotifications />
      <Box component='main' sx={{ flex: 1 }}>
        <Routes>
          {/* New Account */}
          <Route path='/' element={<NewAccount />} />

          {/* Parents */}
          <Route path='parents'>
            <Route index element={<Overview />} />
            <Route path='new' element={<NewParent />} />
            <Route path=':parentId'>
              <Route path='edit' element={<EditParent />} />
            </Route>
          </Route>

          {/* Campers */}
          <Route path='campers'>
            <Route index element={<Overview />} />
            <Route path='new' element={<NewCamper />} />
            <Route path=':camperId'>
              <Route path='edit' element={<EditCamper />} />
            </Route>
          </Route>

          {/* Emergency Contacts */}
          <Route path='emergency_contacts'>
            <Route index element={<Overview />} />
            <Route path='new' element={<NewEmergencyContact />} />
            <Route path=':emergencyContactId'>
              <Route path='edit' element={<EditEmergencyContact />} />
            </Route>
          </Route>

          {/* Pick-up People */}
          <Route path='pickup_people'>
            <Route index element={<Overview />} />
            <Route path='new' element={<NewPickupPerson />} />
            <Route path=':pickupPersonId'>
              <Route path='edit' element={<EditPickupPerson />} />
            </Route>
          </Route>

          {/* Cart, payment, confirm, complete */}
          <Route path='cart' element={<Cart />} />
          <Route path='payment' element={<Payment />} />
          <Route path='confirm' element={<Confirm />} />
          <Route path='complete' element={<Complete />} />

          {/* 404 */}
          <Route path='*' element={<NotFound />} />
        </Routes>
      </Box>
      <AccountFooter />
    </Box>
  </BrowserRouter>
)

export default RegistrationRoutes
